import React from 'react'

/**
 * 
 * @param {import('../types').FormV2FieldProps} param0 
 */
const SwitchV2Field = ({
    label,
    value,
    onChange,
    isRequired,
    isDisabled,
    id,
    name,
    aria,
    classes,
    styles,
    onBlur,
    onFocus,
    lang,
}) => {
    return (
        <div
            className={`toogle-switch2 ${classes?.field || ''}`}
            style={{
                width: 'fit-content',
                maxWidth: '100%',
                ...(styles?.field || {}),
            }}
        >
            <label
                className='switch switch-1'
                style={{
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                }}
                htmlFor={id}
            >
                <span className="switch-text">
                    {label?.translate(lang)}
                </span>
                <input
                    id={id}
                    type='checkbox'
                    checked={value || false}
                    onChange={e => onChange?.(e.target.checked)}
                    onBlur={onBlur}
                    onFocus={onFocus}
                    className={`switch-input`}
                    required={isRequired}
                    disabled={isDisabled}
                    {...aria || {}}
                    name={name}
                />
                <span className='slider round'></span>
            </label>
        </div>
    )
}

export default SwitchV2Field